import { authAxios } from "../utils";
import {
  acceptTicketURL,
  ticketChangeState,
  cancelTicketURL,
  assignTicketURL,
  receiveTicketURL,
  assignDeleteTicketURL,
  assignChangeTicketURL,
  doneTicketURL,
  forwardTicketURL,
  reprocessTicketURL,
  closeTicketURL,
  getPushNotificationURL,
} from "../constants";
import { Modal, notification } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import React from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import dayjs from "dayjs";

const cookies = new Cookies();
const { confirm } = Modal;

export const getPushNotification = () => {
  return authAxios(cookies.get("token")).get(getPushNotificationURL);
};

export const changeState = (params = {}) => {
  return authAxios(cookies.get("token")).post(ticketChangeState, params);
};

export const acceptTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(acceptTicketURL, params);
};

export const deleteTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(cancelTicketURL, params);
};

export const assignAddTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(assignTicketURL, params);
};
export const assignDeleteTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(assignDeleteTicketURL, params);
};

export const assignChangeTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(assignChangeTicketURL, params);
};

export const receiveTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(receiveTicketURL, params);
};

export const doneTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(doneTicketURL, params);
};

export const forwardTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(forwardTicketURL, params);
};
export const reprocessTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(reprocessTicketURL, params);
};
export const closeTicketAPI = (params = {}) => {
  return authAxios(cookies.get("token")).post(closeTicketURL, params);
};

export function showConfirmAccept(
  setLoading,
  ticketid,
  state_to,
  ticketCode,
  actionType,
  fetchTicketDetail
) {
  async function waitForAPI(ticketid) {
    let changeNewState = await acceptTicketAPI({
      ticket_id: ticketid,
      // newstatus: state_to,
      // log_destiny: "",
      // logtype: 1,
    });
    return "done";
  }
  confirm({
    title: `Xác nhận duyệt yêu cầu có mã ${ticketCode}?`,
    icon: <ExclamationCircleOutlined />,
    // content: 'Some descriptions',
    onOk() {
      setLoading(true);
      waitForAPI(ticketid)
        .then((res) => {
          fetchTicketDetail();
          // window.location.reload()
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    },
    onCancel() {
      setLoading(false);
    },
  });
}

export function showConfirmProcess(
  setLoading,
  ticketid,
  state_to,
  ticketCode,
  actionType,
  fetchTicketDetail
) {
  async function waitForAPI(ticketid) {
    let changeNewState = await receiveTicketAPI({
      ticket_id: ticketid,
      newstatus: state_to,
      log_destiny: "",
      logtype: 1,
    });
    // console.log(changeNewState);
    return "done";
  }
  confirm({
    title: `Xác nhận xử lý yêu cầu có mã ${ticketCode}?`,
    icon: <ExclamationCircleOutlined />,
    // content: 'Some descriptions',
    onOk() {
      setLoading(true);
      waitForAPI(ticketid).then((res) => {
        fetchTicketDetail();
        setLoading(false);
        // window.location.reload()
      });
    },
    onCancel() {
      setLoading(false);
    },
  });
}

export function showConfirmClose(
  setLoading,
  ticketid,
  state_to,
  ticketCode,
  actionType,
  fetchTicketDetail
) {
  async function waitForAPI(ticketid) {
    let changeNewState = await closeTicketAPI({
      ticket_id: ticketid,
      newstatus: state_to,
      log_destiny: "",
      logtype: 1,
    });
    // console.log(changeNewState);
    return "done";
  }
  confirm({
    title: `Xác nhận đóng yêu cầu có mã ${ticketCode}?`,
    icon: <ExclamationCircleOutlined />,
    // content: 'Some descriptions',
    onOk() {
      setLoading(true);
      waitForAPI(ticketid).then((res) => {
        fetchTicketDetail();
        // window.location.reload()
        setLoading(false);
      });
    },
    onCancel() {
      setLoading(false);
    },
  });
}

export function openNotificationWithIcon(type, message, description) {
  notification[type]({
    message: message,
    description: description,
  });
}

export function useErrorResizeObserver() {
  // Tạm thời fix lỗi scroll trong Table của Antd, do update version mới của react-dom
  const handleError = (e) => {
    if (
      e.message ===
      "ResizeObserver loop completed with undelivered notifications."
    ) {
      const resizeObserverErrDiv = document.getElementById(
        "webpack-dev-server-client-overlay-div"
      );
      const resizeObserverErr = document.getElementById(
        "webpack-dev-server-client-overlay"
      );
      if (resizeObserverErr) {
        resizeObserverErr.setAttribute("style", "display: none");
      }
      if (resizeObserverErrDiv) {
        resizeObserverErrDiv.setAttribute("style", "display: none");
      }
    }
  };

  window.addEventListener("error", handleError);
  return () => {
    handleError;
  };
}

export function disabledDate(current) {
  // Can not select days after today and today
  return current && current > moment().endOf("day");
}

export function disabledDatePast(current) {
  // Can not select days before today and today
  return current && current < moment().startOf("day");
}

export const validateMessages = {
  required: "${label} là bắt buộc.",
  types: {
    email: "${label} không đúng định dạng.",
    number: "${label} không đúng định dạng.",
  },
  number: {
    range: "${label} phải từ ${min} đến ${max}",
  },
};

const disabledHoursCommon = () => {
  return [0, 1, 2, 3, 4, 5, 6, 18, 19, 20, 21, 22, 23]; // Các giờ bị vô hiệu hóa
};

export const disabledStartTime = (selectedDate) => {
  const currentTime = dayjs(); // Giờ hiện tại
  const currentHour = currentTime.hour();
  const currentMinute = currentTime.minute();

  if (selectedDate && !selectedDate.isSame(moment(), "day")) {
    return { disabledHours: () => disabledHoursCommon() };
  }

  return {
    disabledHours: () =>
      disabledHoursCommon().concat(
        Array.from({ length: currentHour }, (_, i) => i) // Vô hiệu hóa các giờ nhỏ hơn giờ hiện tại
      ),
    disabledMinutes: (selectedHour) => {
      if (selectedHour === currentHour) {
        return Array.from({ length: 60 }, (_, i) => i).filter(
          (minute) => minute <= currentMinute
        );
      }
      return [];
    },
  };
};

export const disabledStartTime_Interview = (selectedDate) => {
  const currentTime = dayjs(); // Giờ hiện tại
  const currentHour = currentTime.hour();
  const currentMinute = currentTime.minute();

  if (selectedDate && !selectedDate.isSame(moment(), "day")) {
    return {};
  }

  return {
    disabledHours: () =>
        Array.from({ length: currentHour }, (_, i) => i) // Vô hiệu hóa các giờ nhỏ hơn giờ hiện tại
      ,
    disabledMinutes: (selectedHour) => {
      if (selectedHour === currentHour) {
        return Array.from({ length: 60 }, (_, i) => i).filter(
          (minute) => minute <= currentMinute
        );
      }
      return [];
    },
  };
};

export const useScreenSize = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};

// export const pdfBox = ()=>{
//     pdfjs.GlobalWorkerOptions.workerSrc =
//     `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
//      const [numPages, setNumPages] = useState(null);
//       const [pageNumber, setPageNumber] = useState(1);

//         function onDocumentLoadSuccess({ numPages }) {
//         setNumPages(numPages);
//         setPageNumber(1);
//       }
//       return (
//         <>
//         <div className="main">
//           <Document
//             file={url}
//             onLoadSuccess={onDocumentLoadSuccess}
//             >
//             <Page pageNumber={pageNumber} />
//           </Document>
//          </div>
//         </>
//       );
// }
